import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { homeForRole } from 'src/app/data/Menu/event-menus';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {

  constructor(protected router: Router, private auth:AuthService) { }

  ngOnInit() {}

  toHome(){
    if(this.auth.getCountryFromLocalStorage() != null ){
      this.router.navigate([homeForRole(this.auth.role)]);
    }else{
      this.router.navigate(['/login']);
    }
  }
}
